// src/components/panels/LyricsPanel.jsx
import { Link, NavLink, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

const DescriptionPanel = ({ onClose, track, tracklist }) => {

  var cr = 0;

  return (
    <div className="options-content">
      <div className="panel large p-20l-10s">
        <div className="horizontal-container justify-left gap-lg-md bb1-555 pb-10l-5s">
          {track ? (
            tracklist.type === 'liked' && track.tracklistImageURL ? (
            <span className="center-everything b1-555">
              <img src={track.tracklistImageURL} alt={track.tracklistTitle} className="lighten-bright120per-contrast115per hide-for-small-only" width="50" />
              <img src={track.tracklistImageURL} alt={track.tracklistTitle} className="lighten-bright120per-contrast115per show-for-small-only" width="35" />
            </span>
            ) : (
            <span className="center-everything b1-555">
              <img src={track.image_url} alt={track.title} className="lighten-bright120per-contrast115per hide-for-small-only" width="50" />
              <img src={track.image_url} alt={track.title} className="lighten-bright120per-contrast115per show-for-small-only" width="35" />
            </span>
            )
          ) : (
            /*
            tracklist.type === 'liked' ? (
              <span className="center-everything b1-555">
                <img src={tracklist.image_url} alt={tracklist.title} className="hide-for-small-only" width="50" />
                <img src={tracklist.image_url} alt={tracklist.title} className="show-for-small-only" width="35" />
              </span>
            ) : (
              <span className="center-everything b1-555">
                <img src={tracklist.image_url} alt={tracklist.title} className="lighten-bright120per-contrast115per hide-for-small-only" width="50" />
                <img src={tracklist.image_url} alt={tracklist.title} className="lighten-bright120per-contrast115per show-for-small-only" width="35" />
              </span>
            )
              */
             <></>
          )}
          {track && tracklist.type === 'liked' && track.tracklistTitle ? (
            <span className="">
              <span className="font-orbitron font-size-20l-18m-16s font-weight-800 txt-fff letter-spacing-0px italic">{track.title}</span>
              <div className="font-orbitron font-size-18l-16m-14s font-weight-500 txt-fff letter-spacing-0px italic uppercasse pt-10l-5s">{track ? track.tracklistTitle : ''}</div>
            </span>
          ) : (
            track && tracklist.type !== 'liked' ? (
              <span className="">
                <span className="font-orbitron font-size-20l-18m-16s font-weight-800 txt-fff letter-spacing-0px italic">{track.title}</span>
                <div className="font-orbitron font-size-18l-16m-14s font-weight-500 txt-fff letter-spacing-0px italic uppercasse pt-10l-5s">{tracklist ? tracklist.title : ''}</div>
              </span>
            ) : (
              /*
              <span className="">
                <span className="font-orbitron font-size-20l-18m-16s font-weight-800 txt-fff letter-spacing-0px italic">{tracklist ? tracklist.title : ''}</span>
              </span>
              */
             <></>
            )
          )}
          {!track && !tracklist && (
            <span className="">
              <div className="font-poppins font-size-16 font-weight-500 txt-fff">No track or tracklist loaded</div>
            </span>
          )}
          <span className="align-right pr-10">
            <Link className="font-poppins font-size-18l-16m font-weight-500" onClick={onClose}>Close</Link>
          </span>
        </div>

        <div className="scrollable ptb-10">
          {track !== null && track.description && track.description !== '' && (
            <div className="font-poppins font-size-18l-16m font-weight-400 txt-ddd justify line-height-120per p-0l-10s" dangerouslySetInnerHTML={{ __html: track.description }} />
          )}

          {track === null && tracklist !== null && tracklist.description && tracklist.description !== '' && (
            <div className="grid-x">
              <div className="large-4 medium-5 small-12 cell pr-5l-0s">

                <div className="text-overlay-wrapper text-center">
                  <div className="text-overlay-1020-bottom50">
                    <div className="position-align-bottom pb-10 text-center">
                      <div className="font-orbitron font-size-18l-16m-14s font-weight-800 txt-fff letter-spacing-0px uppercase italic">
                        {tracklist.title}
                      </div>
                    </div>
                  </div>
                  <img src={tracklist.image_url} className="b1-777 show-for-small-only" alt="romergence image" width="75%" />
                  <img src={tracklist.image_url} className="b1-777 hide-for-small-only" alt="romergence image" width="100%" />
                </div>
              </div>
              <div className="large-8 medium-7 small-12 cell pl-5l-0s">
                <div className="font-poppins font-size-18l-16m font-weight-400 txt-ddd justify line-height-120per pt-0l-10s" dangerouslySetInnerHTML={{ __html: tracklist.description }} />
              </div>
            </div>
          )}
        </div>

        <div className="horizontal-container justify-right bt1-555 ptb-10 pr-10">
          <Link className="font-poppins font-size-18l-16m font-weight-500" onClick={onClose}>Close</Link>
        </div>
      </div>
    </div >
  );
};

export default DescriptionPanel;
